















import Vue from 'vue';
import RemarkControl from '../components/remarks/RemarkControl.vue';
import RemarkBody from '../components/remarks/RemarkBody.vue';
import customerClient from '../apis';

export default Vue.extend({
  components: {
    RemarkControl,
    RemarkBody,
  },
  data() {
    return {
      mergeMode: false,
      showRemarkImport: false,
    };
  },
  methods: {
    cancelMerge() {
      this.mergeMode = false;
      this.$store.commit('CANCEL_MERGE_REMARKS');
    },
    doRefreshRemarks() {
      (this.$refs.body as any).getRemarks();
    },
  },
});
